import { ErrorHandler, Injectable } from '@angular/core';
import { AppInsightsService } from './app-insights.service';
import { IErrorService } from '@microsoft/applicationinsights-angularplugin-js';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService extends ErrorHandler implements IErrorService {

    constructor(private appInsightsService: AppInsightsService) {
        super();
    }

    override handleError(error: Error) {
        this.appInsightsService.logException(error);
    }
}
